import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import SelectAcerBrag from '../../components/SelectAcerBrag';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import userAPI from '../../services/UserApi';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import { AppContext } from '../../contexts/AppContext';
import { isValidEmail } from '../../utils/MiscellaneousUtils';
import { separations } from '../../constants/StyleConstants';
import { Fragment } from 'react';
import EmployeesApi from '../../services/EmployeesApi';
import CreateUserPasswordModal from '../UsersAdministration/CreateUserPasswordModal';


const useStyles = makeStyles(theme => ({
  ...separations,
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '30em',
  },
  contiguous: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '1em',
  },
}));

const CreateEmployeeDialog = ({ open, setOpen, readOnly, employeeId, supplierId, reloadGrid }) => {
  const classes = useStyles();
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [name, setName] = useState('');
  const [id, setId] = useState('');
  const [email, setEmail] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());
  
  const [status, setStatus] = useState('');
  
  const [password, setPassword] = useState('');
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
 

  const [employeeFound, setEmployeeFound] = useState(false);
  const [firstVerify, setFirstVerify] = useState(false);
  const [employeeActive, setEmployeeActive] = useState(false);
  

  const resetFields = () => {
    setName('');
    setEmail('');
    setSelectedDate(new Date());
    setStatus('');
    setId('');
    setPassword('');
    setEmployeeFound(false);
    setFirstVerify(false);
  };

  useEffect(() => {
    if (open && employeeId) {
      setOpenBackDrop(true);
      userAPI.getUserById(employeeId).then(res => {
        setName(res.fullName);
       
        setEmail(res.email);
        
        setSelectedDate(res.startDate);
        setStatus(res.state);
      
        setOpenBackDrop(false);
      });
    } else {
      setTimeout(() => {
        resetFields();
      }, 500);

      
      setFirstVerify(false)
    }
  }, [open, employeeId]);

  const finish = () => {
    setOpen(false);
    setTimeout(() => {
      resetFields();
      setOpenBackDrop(false);
    }, 500);


  };


  const newEmployee = async () => {

    const request = {
      UserName: id,
      Email: email,
      FullName: name,
      PwdUserLogged: password,
      SupplierId: supplierId
    };

    EmployeesApi
      .newEmployee(request)
      .then(result => {
        reloadGrid();
        finish();
        showSuccess('Empleado creado con éxito');
      })
      .catch(error => {
        finish();

        if(error.response){
          showWarning(error.response.data);
        } else {
          
          showError('No se pudo crear el nuevo empleado');
        }

      });
  };


  const handleSave = () => {
    setOpenBackDrop(true);
    setOpenPasswordModal(true);
    
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = name.isBlank())) {
      errorMessages.push('Debe completar el nombre del empleado');
    }

    if ((errors[i++] = email.isBlank())) {
      errorMessages.push('Debe completar el email del empleado');
    } else if ((errors[i++] = !isValidEmail(email))) {
      errorMessages.push('El email ingresado no es válido');
    }

    if((errors[i++] = employeeFound && !employeeActive)){
      errorMessages.push('El email ingresado se encuentra inactivo. Se debe activar para ser usado.');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSave = () => validate() && handleSave();

  const verifyEmployee = () => {


    const request = {
      Email: email
    }

    !firstVerify && setFirstVerify(true);

    EmployeesApi.get(request)
    .then(res => {
      
      if(res){
        setName(res.fullName);
        setEmployeeFound(true);

        setEmployeeActive(res.enabled);

      } else {
        setName('');
        setEmployeeFound(false);
      }
    })
    .catch(error => showError("Error al verificar la existencia del empleado"))
  }


  return (
    <Fragment>

      <CreateUserPasswordModal
        open={openPasswordModal}
        setOpen={setOpenPasswordModal}
        password={password}
        setPassword={setPassword}
        onCancel={() => {
          setOpenPasswordModal(false);
          setOpenBackDrop(false);
        }}
        newUser={newEmployee}
      />

      <DialogAcerBrag
        open={open}
        setOpen={setOpen}
      
        title={'Nuevo empleado'}
        action={!readOnly ? validateAndSave : undefined}>
        <LimitedBackdrop open={openBackDrop}>
          <CircularProgress color="primary" />
        </LimitedBackdrop>
        <div className={classes.dialogContainer}>

          <TextField
            margin="dense"
            id="email"
            label="Email"
            onChange={e => setEmail(e.target.value)}
            onBlur={() => verifyEmployee()}
            value={email}
            
          />

          <TextField
            fullWidth
            margin="dense"
            id="razonSocialNombreYApellido"
            label="Nombre"
            onChange={e => setName(e.target.value)}
            value={name}
            inputProps={{ readOnly: !firstVerify || employeeFound }}
          />


          <div className={classes.separationBetween}>
            <CustomDatePicker readOnly value={selectedDate} setValue={setSelectedDate} />
            <SelectAcerBrag
              stretch={readOnly}
              readOnly={readOnly || !employeeId}
              rows={[
                { id: true, name: 'Activo' }
              ]}
              value={!employeeId ? true : status}
              setValue={setStatus}
              selectTitle="Estado"
            />
          </div>

        </div>
      </DialogAcerBrag>
    </Fragment>
  );
};
export default CreateEmployeeDialog;